import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import authService from '../services/authService';
import { getApiBaseUrl } from '../config/apiConfig';
import { AppSpinner } from '../components/ui';

const GoogleCallbackPage = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    const handleGoogleCallback = async () => {
      try {
        // Récupérer le token depuis l'URL
        const token = searchParams.get('token');
        const error = searchParams.get('error');

        if (error) {
          throw new Error(decodeURIComponent(error));
        }

        if (!token) {
          throw new Error('Token manquant');
        }

        // Valider le token avec l'API
        const response = await fetch(`${getApiBaseUrl()}/auth/validate`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (!response.ok) {
          throw new Error('Token invalide');
        }

        const data = await response.json();
        
        if (data.success && data.data) {
          // Sauvegarder les informations utilisateur
          authService.token = token;
          authService.user = data.data.user;
          
          localStorage.setItem('auth_token', token);
          localStorage.setItem('auth_user', JSON.stringify(data.data.user));
          
          // Rediriger vers la page principale avec rechargement complet
          window.location.href = '/';
        } else {
          throw new Error('Erreur de validation du token');
        }
      } catch (err) {
        console.error('Erreur lors du callback Google:', err);
        setError(err.message || 'Erreur de connexion Google');
      } finally {
        setLoading(false);
      }
    };

    handleGoogleCallback();
  }, [searchParams]);

  if (loading) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="text-center">
          <AppSpinner centered={false} className="mb-3" />
          <p className="text-muted">Finalisation de la connexion...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-6 col-lg-4">
              <div className="card shadow">
                <div className="card-body p-5 text-center">
                  <div className="text-danger mb-4">
                    <i className="ri-error-warning-line" style={{ fontSize: '3rem' }}></i>
                  </div>
                  <h4 className="text-danger mb-3">Erreur de connexion</h4>
                  <p className="text-muted mb-4">{error}</p>
                  <button 
                    className="btn btn-primary"
                    onClick={() => window.location.href = '/login'}
                  >
                    Retour à la connexion
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default GoogleCallbackPage;
